export interface PopularLocation {
  id: string
  slug: string
  name: string
  latitude: number
  longitude: number
  imageUrl: string
  featured: boolean
  startingPrice: number
}

export const popularLocations: PopularLocation[] = [
  {
    id: "casablanca-morocco",
    slug: "casablanca",
    name: "Casablanca, Morocco",
    latitude: 33.5731,
    longitude: -7.5898,
    imageUrl: "/images/cities/casablanca.png",
    featured: true,
    startingPrice: 25,
  },
  {
    id: "rabat-morocco",
    slug: "rabat", 
    name: "Rabat, Morocco",
    latitude: 34.0209,
    longitude: -6.8416,
    imageUrl: "/images/cities/rabat.png",
    featured: true,
    startingPrice: 28,
  },
  {
    id: "agadir-morocco",
    slug: "agadir",
    name: "Agadir, Morocco",
    latitude: 30.4278,
    longitude: -9.5981,
    imageUrl: "/images/cities/agadir.png", 
    featured: true,
    startingPrice: 32,
  },
  {
    id: "meknes-morocco",
    slug: "meknes",
    name: "Meknes, Morocco",
    latitude: 33.8935,
    longitude: -5.5473,
    imageUrl: "/images/cities/meknes.png",
    featured: true,
    startingPrice: 27,
  },
  {
    id: "ifran-morocco",
    slug: "ifran",
    name: "Ifran, Morocco",
    latitude: 33.5228,
    longitude: -5.1106,
    imageUrl: "/images/cities/ifran.png",
    featured: true,
    startingPrice: 35,
  },
  {
    id: "errachidia-morocco",
    slug: "errachidia",
    name: "Errachidia, Morocco",
    latitude: 31.9314,
    longitude: -4.4242,
    imageUrl: "/images/cities/errachidia.png",
    featured: true,
    startingPrice: 30,
  },
  // International destinations using the copied images
  {
    id: "paris-france",
    slug: "paris",
    name: "Paris, France",
    latitude: 48.8589,
    longitude: 2.3469,
    imageUrl: "/images/locations/paris.jpg",
    featured: true,
    startingPrice: 69,
  },
  {
    id: "dubai-uae",
    slug: "dubai", 
    name: "Dubai, UAE",
    latitude: 25.2652,
    longitude: 55.2928,
    imageUrl: "/images/locations/dubai.jpg",
    featured: true,
    startingPrice: 67,
  },
  {
    id: "rome-italy",
    slug: "rome",
    name: "Rome, Italy", 
    latitude: 41.8931,
    longitude: 12.4832,
    imageUrl: "/images/locations/rome.jpg",
    featured: true,
    startingPrice: 78,
  },
  {
    id: "sydney-australia",
    slug: "sydney",
    name: "Sydney, Australia",
    latitude: -33.8693,
    longitude: 151.209,
    imageUrl: "/images/locations/sydney.jpg",
    featured: true,
    startingPrice: 57,
  }
]

export const featuredLocations = popularLocations.filter(location => location.featured)
